module.exports = __webpack_public_path__ + "assets/images/embed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/embed.svg
// module id = 499
// module chunks = 0